import Layout from "../layout/Layout";

export default function MyVideos() {
    return <Layout>
        My videos page.
    </Layout>;
}